import Grid from "@mui/material/Grid";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import RefreshIcon from "@mui/icons-material/Refresh";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

// Extracted from RadioInformation.jsx so this same date-range control can be
// rendered once and shared by both RadioInformation and CellTowerMap
// (DeviceManagement.jsx), instead of each having its own independent picker.
function RadioDateRangePicker(props) {
  return (
    <Grid container spacing={2} justifyContent={"space-around"}>
      <Grid item xs={12} md={2} lg={2}>
        <FormControl component="fieldset">
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  onChange={(event) =>
                    props.onGetByArrivalDateChange(event.target.checked)
                  }
                  checked={props.getByArrivalDate}
                  color="primary"
                />
              }
              label={props.getByArrivalDate ? "Arrival Date" : "Timestamp"}
              labelPlacement="end"
            />
          </FormGroup>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={2} lg={2}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            disableToolbar
            variant="inline"
            format="MM/dd/yyyy"
            margin="normal"
            id="date-picker-inline"
            label="Start Date"
            value={props.startDate}
            onChange={props.onStartDateChange}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} md={2} lg={2}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <TimePicker
            margin="normal"
            id="time-picker"
            label="Start Time"
            value={props.startDate}
            onChange={props.onStartDateChange}
            KeyboardButtonProps={{
              "aria-label": "change time",
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} md={2} lg={2}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            disableToolbar
            variant="inline"
            format="MM/dd/yyyy"
            margin="normal"
            id="date-picker-inline"
            label="End Date"
            value={props.endDate}
            onChange={props.onEndDateChange}
            KeyboardButtonProps={{
              "aria-label": "change date",
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} md={2} lg={2}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <TimePicker
            margin="normal"
            id="time-picker"
            label="End Time"
            value={props.endDate}
            onChange={props.onEndDateChange}
            KeyboardButtonProps={{
              "aria-label": "change time",
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} md={1} lg={1}>
        <IconButton onClick={props.onRefresh}>
          <RefreshIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
}

export default RadioDateRangePicker;
